import { watch, onUnmounted } from 'vue';
import { disableScrollOnModalOpen } from 'src/utils/helper/misc';
import { MdTypography, MdModal, MdIconClose } from '@antiqua-dls/vue-components';
import SmartStars from 'src/components/icons/smart-stars';
import { useI18n } from 'vue-i18n';

export default {
  name: 'AiInfoModal',
  components: {
    MdTypography,
    MdModal,
    MdIconClose
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['cancel'],
  setup(props) {
    const { t } = useI18n();

    const textsToRender = [
      {
        icon: SmartStars,
        heading: t('pages.aiTextEditor.ai_info_modal.boost.header'),
        subHeading: t('pages.aiTextEditor.ai_info_modal.boost.sub_header')
      },
      {
        icon: SmartStars,
        heading: t('pages.aiTextEditor.ai_info_modal.refine.header'),
        subHeading: t('pages.aiTextEditor.ai_info_modal.refine.sub_header')
      },
      {
        icon: SmartStars,
        heading: t('pages.aiTextEditor.ai_info_modal.grammar.header'),
        subHeading: t('pages.aiTextEditor.ai_info_modal.grammar.sub_header')
      },
      {
        icon: SmartStars,
        heading: t('pages.aiTextEditor.ai_info_modal.short.header'),
        subHeading: t('pages.aiTextEditor.ai_info_modal.short.sub_header')
      }
    ];

    watch(
      () => props.show,
      newVal => {
        disableScrollOnModalOpen(newVal, true);
      },
      { immediate: true }
    );

    onUnmounted(() => {
      disableScrollOnModalOpen(false, true);
    });

    return {
      textsToRender
    };
  }
};
